'use client';

import { Skeleton } from '@/components/Skeleton';
import { useDevice } from '@/hooks/device';
import { ScSliderLayoutContent } from '@/layouts/styled';
import { LobbySliderSkeleton } from '@/modules/common';
import { ScContainer } from '@/styles/common';
import GamesSkeleton from './GamesSkeleton';

interface ILobbyPageSkeleton {
  withTitle?: boolean;
}

export default function LobbyPageSkeleton({ withTitle }: ILobbyPageSkeleton) {
  const { isMobileDevice } = useDevice();

  return (
    <>
      <LobbySliderSkeleton />
      <ScSliderLayoutContent>
        <ScContainer>
          <Skeleton.Container
            alignItems="center"
            flexDirection="column"
            gap={12}
            marginBottom={12}
            padding="20px 0px 12px"
          >
            <Skeleton.Container padding="4px 0px">
              <Skeleton.Rect height={40} />
            </Skeleton.Container>
            <Skeleton.Rect
              height={40}
              width={isMobileDevice ? '100%' : '50%'}
            />
          </Skeleton.Container>
          <GamesSkeleton withTitle={withTitle} />
        </ScContainer>
      </ScSliderLayoutContent>
    </>
  );
}
